/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as TermsTrialImport } from './routes/terms-trial'
import { Route as RegisterImport } from './routes/register'
import { Route as PrivacyImport } from './routes/privacy'
import { Route as LogoutImport } from './routes/logout'
import { Route as LoginImport } from './routes/login'
import { Route as AuthImport } from './routes/_auth'
import { Route as AuthIndexImport } from './routes/_auth/index'
import { Route as AuthWelcomeImport } from './routes/_auth/welcome'
import { Route as AuthEndOfTrialImport } from './routes/_auth/end-of-trial'
import { Route as AuthAcademyImport } from './routes/_auth/academy'
import { Route as AccountVerifyCompleteSignupImport } from './routes/account/verify/complete-signup'
import { Route as AccountVerifyCompleteInviteImport } from './routes/account/verify/complete-invite'
import { Route as AccountPasswordRequestImport } from './routes/account/password/request'
import { Route as AuthAccountProfileImport } from './routes/_auth/account/profile'
import { Route as AuthWorkspacesWorkspaceidIndexImport } from './routes/_auth/workspaces/$workspace_id/index'
import { Route as AccountVerifyTypeTokenImport } from './routes/account/verify/$type/$token'
import { Route as AuthWorkspacesWorkspaceidOverviewImport } from './routes/_auth/workspaces/$workspace_id/overview'
import { Route as AuthWorkspacesWorkspaceidCustomerWorkspacesImport } from './routes/_auth/workspaces/$workspace_id/customer-workspaces'
import { Route as AuthAccountPasswordSetImport } from './routes/_auth/account/password/set'
import { Route as AuthAccountPasswordResetImport } from './routes/_auth/account/password/reset'
import { Route as AuthWorkspacesWorkspaceidDeviceInsightsRouteImport } from './routes/_auth/workspaces/$workspace_id/device-insights/route'
import { Route as AuthWorkspacesWorkspaceidMaintenancesIndexImport } from './routes/_auth/workspaces/$workspace_id/maintenances/index'
import { Route as AuthWorkspacesWorkspaceidMaintenanceStrategiesIndexImport } from './routes/_auth/workspaces/$workspace_id/maintenance-strategies/index'
import { Route as AuthWorkspacesWorkspaceidDevicesIndexImport } from './routes/_auth/workspaces/$workspace_id/devices/index'
import { Route as AuthWorkspacesWorkspaceidDeploymentsIndexImport } from './routes/_auth/workspaces/$workspace_id/deployments/index'
import { Route as AuthWorkspacesWorkspaceidChecklistTemplatesIndexImport } from './routes/_auth/workspaces/$workspace_id/checklist-templates/index'
import { Route as AuthWorkspacesWorkspaceidCasesIndexImport } from './routes/_auth/workspaces/$workspace_id/cases/index'
import { Route as AuthWorkspacesWorkspaceidSettingsProfileImport } from './routes/_auth/workspaces/$workspace_id/settings/profile'
import { Route as AuthWorkspacesWorkspaceidSettingsDetailsImport } from './routes/_auth/workspaces/$workspace_id/settings/details'
import { Route as AuthWorkspacesWorkspaceidInventoryConstraintsImport } from './routes/_auth/workspaces/$workspace_id/inventory/constraints'
import { Route as AuthWorkspacesWorkspaceidInventoryAssembledImport } from './routes/_auth/workspaces/$workspace_id/inventory/assembled'
import { Route as AuthWorkspacesWorkspaceidInventoryActivitiesImport } from './routes/_auth/workspaces/$workspace_id/inventory/activities'
import { Route as AuthWorkspacesWorkspaceidSettingsTagsRouteImport } from './routes/_auth/workspaces/$workspace_id/settings/tags/route'
import { Route as AuthWorkspacesWorkspaceidSettingsCustomInventoryRouteImport } from './routes/_auth/workspaces/$workspace_id/settings/custom-inventory/route'
import { Route as AuthWorkspacesWorkspaceidMaintenancesTypeRouteImport } from './routes/_auth/workspaces/$workspace_id/maintenances/type/route'
import { Route as AuthWorkspacesWorkspaceidCasesTypeRouteImport } from './routes/_auth/workspaces/$workspace_id/cases/type/route'
import { Route as AuthWorkspacesWorkspaceidSettingsAccessIndexImport } from './routes/_auth/workspaces/$workspace_id/settings/access/index'
import { Route as AuthWorkspacesWorkspaceidMaintenancesMaintenanceidIndexImport } from './routes/_auth/workspaces/$workspace_id/maintenances/$maintenance_id/index'
import { Route as AuthWorkspacesWorkspaceidMaintenanceStrategiesMaintenancestrategyidIndexImport } from './routes/_auth/workspaces/$workspace_id/maintenance-strategies/$maintenance_strategy_id/index'
import { Route as AuthWorkspacesWorkspaceidInventoryPartsIndexImport } from './routes/_auth/workspaces/$workspace_id/inventory/parts/index'
import { Route as AuthWorkspacesWorkspaceidDevicesDeviceidIndexImport } from './routes/_auth/workspaces/$workspace_id/devices/$device_id/index'
import { Route as AuthWorkspacesWorkspaceidDeviceInsightsTypeIndexImport } from './routes/_auth/workspaces/$workspace_id/device-insights/$type/index'
import { Route as AuthWorkspacesWorkspaceidDeploymentsDeploymentidIndexImport } from './routes/_auth/workspaces/$workspace_id/deployments/$deployment_id/index'
import { Route as AuthWorkspacesWorkspaceidChecklistTemplatesChecklisttemplateidIndexImport } from './routes/_auth/workspaces/$workspace_id/checklist-templates/$checklist_template_id/index'
import { Route as AuthWorkspacesWorkspaceidCasesCaseidIndexImport } from './routes/_auth/workspaces/$workspace_id/cases/$case_id/index'
import { Route as AuthWorkspacesWorkspaceidSettingsTagsTypeIndexImport } from './routes/_auth/workspaces/$workspace_id/settings/tags/$type/index'
import { Route as AuthWorkspacesWorkspaceidSettingsCustomInventoryTypeIndexImport } from './routes/_auth/workspaces/$workspace_id/settings/custom-inventory/$type/index'
import { Route as AuthWorkspacesWorkspaceidMaintenancesTypeTypeIndexImport } from './routes/_auth/workspaces/$workspace_id/maintenances/type/$type/index'
import { Route as AuthWorkspacesWorkspaceidInventoryPartsPartidIndexImport } from './routes/_auth/workspaces/$workspace_id/inventory/parts/$part_id/index'
import { Route as AuthWorkspacesWorkspaceidCasesTypeTypeIndexImport } from './routes/_auth/workspaces/$workspace_id/cases/type/$type/index'
import { Route as AuthWorkspacesWorkspaceidSettingsAccessUsersUseridIndexImport } from './routes/_auth/workspaces/$workspace_id/settings/access/users/$user_id/index'
import { Route as AuthWorkspacesWorkspaceidMaintenancesMaintenanceidDevicesDeviceidIndexImport } from './routes/_auth/workspaces/$workspace_id/maintenances/$maintenance_id/devices/$device_id/index'
import { Route as AuthWorkspacesWorkspaceidDevicesDeviceidPartsPartidIndexImport } from './routes/_auth/workspaces/$workspace_id/devices/$device_id/parts/$part_id/index'
import { Route as AuthWorkspacesWorkspaceidDeploymentsDeploymentidUsersUseridIndexImport } from './routes/_auth/workspaces/$workspace_id/deployments/$deployment_id/users/$user_id/index'

// Create/Update Routes

const TermsTrialRoute = TermsTrialImport.update({
  id: '/terms-trial',
  path: '/terms-trial',
  getParentRoute: () => rootRoute,
} as any)

const RegisterRoute = RegisterImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRoute,
} as any)

const PrivacyRoute = PrivacyImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRoute,
} as any)

const LogoutRoute = LogoutImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const AuthRoute = AuthImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const AuthIndexRoute = AuthIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWelcomeRoute = AuthWelcomeImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => AuthRoute,
} as any)

const AuthEndOfTrialRoute = AuthEndOfTrialImport.update({
  id: '/end-of-trial',
  path: '/end-of-trial',
  getParentRoute: () => AuthRoute,
} as any)

const AuthAcademyRoute = AuthAcademyImport.update({
  id: '/academy',
  path: '/academy',
  getParentRoute: () => AuthRoute,
} as any)

const AccountVerifyCompleteSignupRoute =
  AccountVerifyCompleteSignupImport.update({
    id: '/account/verify/complete-signup',
    path: '/account/verify/complete-signup',
    getParentRoute: () => rootRoute,
  } as any)

const AccountVerifyCompleteInviteRoute =
  AccountVerifyCompleteInviteImport.update({
    id: '/account/verify/complete-invite',
    path: '/account/verify/complete-invite',
    getParentRoute: () => rootRoute,
  } as any)

const AccountPasswordRequestRoute = AccountPasswordRequestImport.update({
  id: '/account/password/request',
  path: '/account/password/request',
  getParentRoute: () => rootRoute,
} as any)

const AuthAccountProfileRoute = AuthAccountProfileImport.update({
  id: '/account/profile',
  path: '/account/profile',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWorkspacesWorkspaceidIndexRoute =
  AuthWorkspacesWorkspaceidIndexImport.update({
    id: '/workspaces/$workspace_id/',
    path: '/workspaces/$workspace_id/',
    getParentRoute: () => AuthRoute,
  } as any)

const AccountVerifyTypeTokenRoute = AccountVerifyTypeTokenImport.update({
  id: '/account/verify/$type/$token',
  path: '/account/verify/$type/$token',
  getParentRoute: () => rootRoute,
} as any)

const AuthWorkspacesWorkspaceidOverviewRoute =
  AuthWorkspacesWorkspaceidOverviewImport.update({
    id: '/workspaces/$workspace_id/overview',
    path: '/workspaces/$workspace_id/overview',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthWorkspacesWorkspaceidCustomerWorkspacesRoute =
  AuthWorkspacesWorkspaceidCustomerWorkspacesImport.update({
    id: '/workspaces/$workspace_id/customer-workspaces',
    path: '/workspaces/$workspace_id/customer-workspaces',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthAccountPasswordSetRoute = AuthAccountPasswordSetImport.update({
  id: '/account/password/set',
  path: '/account/password/set',
  getParentRoute: () => AuthRoute,
} as any)

const AuthAccountPasswordResetRoute = AuthAccountPasswordResetImport.update({
  id: '/account/password/reset',
  path: '/account/password/reset',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWorkspacesWorkspaceidDeviceInsightsRouteRoute =
  AuthWorkspacesWorkspaceidDeviceInsightsRouteImport.update({
    id: '/workspaces/$workspace_id/device-insights',
    path: '/workspaces/$workspace_id/device-insights',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthWorkspacesWorkspaceidMaintenancesIndexRoute =
  AuthWorkspacesWorkspaceidMaintenancesIndexImport.update({
    id: '/workspaces/$workspace_id/maintenances/',
    path: '/workspaces/$workspace_id/maintenances/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthWorkspacesWorkspaceidMaintenanceStrategiesIndexRoute =
  AuthWorkspacesWorkspaceidMaintenanceStrategiesIndexImport.update({
    id: '/workspaces/$workspace_id/maintenance-strategies/',
    path: '/workspaces/$workspace_id/maintenance-strategies/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthWorkspacesWorkspaceidDevicesIndexRoute =
  AuthWorkspacesWorkspaceidDevicesIndexImport.update({
    id: '/workspaces/$workspace_id/devices/',
    path: '/workspaces/$workspace_id/devices/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthWorkspacesWorkspaceidDeploymentsIndexRoute =
  AuthWorkspacesWorkspaceidDeploymentsIndexImport.update({
    id: '/workspaces/$workspace_id/deployments/',
    path: '/workspaces/$workspace_id/deployments/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthWorkspacesWorkspaceidChecklistTemplatesIndexRoute =
  AuthWorkspacesWorkspaceidChecklistTemplatesIndexImport.update({
    id: '/workspaces/$workspace_id/checklist-templates/',
    path: '/workspaces/$workspace_id/checklist-templates/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthWorkspacesWorkspaceidCasesIndexRoute =
  AuthWorkspacesWorkspaceidCasesIndexImport.update({
    id: '/workspaces/$workspace_id/cases/',
    path: '/workspaces/$workspace_id/cases/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthWorkspacesWorkspaceidSettingsProfileRoute =
  AuthWorkspacesWorkspaceidSettingsProfileImport.update({
    id: '/workspaces/$workspace_id/settings/profile',
    path: '/workspaces/$workspace_id/settings/profile',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthWorkspacesWorkspaceidSettingsDetailsRoute =
  AuthWorkspacesWorkspaceidSettingsDetailsImport.update({
    id: '/workspaces/$workspace_id/settings/details',
    path: '/workspaces/$workspace_id/settings/details',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthWorkspacesWorkspaceidInventoryConstraintsRoute =
  AuthWorkspacesWorkspaceidInventoryConstraintsImport.update({
    id: '/workspaces/$workspace_id/inventory/constraints',
    path: '/workspaces/$workspace_id/inventory/constraints',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthWorkspacesWorkspaceidInventoryAssembledRoute =
  AuthWorkspacesWorkspaceidInventoryAssembledImport.update({
    id: '/workspaces/$workspace_id/inventory/assembled',
    path: '/workspaces/$workspace_id/inventory/assembled',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthWorkspacesWorkspaceidInventoryActivitiesRoute =
  AuthWorkspacesWorkspaceidInventoryActivitiesImport.update({
    id: '/workspaces/$workspace_id/inventory/activities',
    path: '/workspaces/$workspace_id/inventory/activities',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthWorkspacesWorkspaceidSettingsTagsRouteRoute =
  AuthWorkspacesWorkspaceidSettingsTagsRouteImport.update({
    id: '/workspaces/$workspace_id/settings/tags',
    path: '/workspaces/$workspace_id/settings/tags',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthWorkspacesWorkspaceidSettingsCustomInventoryRouteRoute =
  AuthWorkspacesWorkspaceidSettingsCustomInventoryRouteImport.update({
    id: '/workspaces/$workspace_id/settings/custom-inventory',
    path: '/workspaces/$workspace_id/settings/custom-inventory',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthWorkspacesWorkspaceidMaintenancesTypeRouteRoute =
  AuthWorkspacesWorkspaceidMaintenancesTypeRouteImport.update({
    id: '/workspaces/$workspace_id/maintenances/type',
    path: '/workspaces/$workspace_id/maintenances/type',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthWorkspacesWorkspaceidCasesTypeRouteRoute =
  AuthWorkspacesWorkspaceidCasesTypeRouteImport.update({
    id: '/workspaces/$workspace_id/cases/type',
    path: '/workspaces/$workspace_id/cases/type',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthWorkspacesWorkspaceidSettingsAccessIndexRoute =
  AuthWorkspacesWorkspaceidSettingsAccessIndexImport.update({
    id: '/workspaces/$workspace_id/settings/access/',
    path: '/workspaces/$workspace_id/settings/access/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthWorkspacesWorkspaceidMaintenancesMaintenanceidIndexRoute =
  AuthWorkspacesWorkspaceidMaintenancesMaintenanceidIndexImport.update({
    id: '/workspaces/$workspace_id/maintenances/$maintenance_id/',
    path: '/workspaces/$workspace_id/maintenances/$maintenance_id/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthWorkspacesWorkspaceidMaintenanceStrategiesMaintenancestrategyidIndexRoute =
  AuthWorkspacesWorkspaceidMaintenanceStrategiesMaintenancestrategyidIndexImport.update(
    {
      id: '/workspaces/$workspace_id/maintenance-strategies/$maintenance_strategy_id/',
      path: '/workspaces/$workspace_id/maintenance-strategies/$maintenance_strategy_id/',
      getParentRoute: () => AuthRoute,
    } as any,
  )

const AuthWorkspacesWorkspaceidInventoryPartsIndexRoute =
  AuthWorkspacesWorkspaceidInventoryPartsIndexImport.update({
    id: '/workspaces/$workspace_id/inventory/parts/',
    path: '/workspaces/$workspace_id/inventory/parts/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthWorkspacesWorkspaceidDevicesDeviceidIndexRoute =
  AuthWorkspacesWorkspaceidDevicesDeviceidIndexImport.update({
    id: '/workspaces/$workspace_id/devices/$device_id/',
    path: '/workspaces/$workspace_id/devices/$device_id/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthWorkspacesWorkspaceidDeviceInsightsTypeIndexRoute =
  AuthWorkspacesWorkspaceidDeviceInsightsTypeIndexImport.update({
    id: '/$type/',
    path: '/$type/',
    getParentRoute: () => AuthWorkspacesWorkspaceidDeviceInsightsRouteRoute,
  } as any)

const AuthWorkspacesWorkspaceidDeploymentsDeploymentidIndexRoute =
  AuthWorkspacesWorkspaceidDeploymentsDeploymentidIndexImport.update({
    id: '/workspaces/$workspace_id/deployments/$deployment_id/',
    path: '/workspaces/$workspace_id/deployments/$deployment_id/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthWorkspacesWorkspaceidChecklistTemplatesChecklisttemplateidIndexRoute =
  AuthWorkspacesWorkspaceidChecklistTemplatesChecklisttemplateidIndexImport.update(
    {
      id: '/workspaces/$workspace_id/checklist-templates/$checklist_template_id/',
      path: '/workspaces/$workspace_id/checklist-templates/$checklist_template_id/',
      getParentRoute: () => AuthRoute,
    } as any,
  )

const AuthWorkspacesWorkspaceidCasesCaseidIndexRoute =
  AuthWorkspacesWorkspaceidCasesCaseidIndexImport.update({
    id: '/workspaces/$workspace_id/cases/$case_id/',
    path: '/workspaces/$workspace_id/cases/$case_id/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthWorkspacesWorkspaceidSettingsTagsTypeIndexRoute =
  AuthWorkspacesWorkspaceidSettingsTagsTypeIndexImport.update({
    id: '/$type/',
    path: '/$type/',
    getParentRoute: () => AuthWorkspacesWorkspaceidSettingsTagsRouteRoute,
  } as any)

const AuthWorkspacesWorkspaceidSettingsCustomInventoryTypeIndexRoute =
  AuthWorkspacesWorkspaceidSettingsCustomInventoryTypeIndexImport.update({
    id: '/$type/',
    path: '/$type/',
    getParentRoute: () =>
      AuthWorkspacesWorkspaceidSettingsCustomInventoryRouteRoute,
  } as any)

const AuthWorkspacesWorkspaceidMaintenancesTypeTypeIndexRoute =
  AuthWorkspacesWorkspaceidMaintenancesTypeTypeIndexImport.update({
    id: '/$type/',
    path: '/$type/',
    getParentRoute: () => AuthWorkspacesWorkspaceidMaintenancesTypeRouteRoute,
  } as any)

const AuthWorkspacesWorkspaceidInventoryPartsPartidIndexRoute =
  AuthWorkspacesWorkspaceidInventoryPartsPartidIndexImport.update({
    id: '/workspaces/$workspace_id/inventory/parts/$part_id/',
    path: '/workspaces/$workspace_id/inventory/parts/$part_id/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthWorkspacesWorkspaceidCasesTypeTypeIndexRoute =
  AuthWorkspacesWorkspaceidCasesTypeTypeIndexImport.update({
    id: '/$type/',
    path: '/$type/',
    getParentRoute: () => AuthWorkspacesWorkspaceidCasesTypeRouteRoute,
  } as any)

const AuthWorkspacesWorkspaceidSettingsAccessUsersUseridIndexRoute =
  AuthWorkspacesWorkspaceidSettingsAccessUsersUseridIndexImport.update({
    id: '/workspaces/$workspace_id/settings/access/users/$user_id/',
    path: '/workspaces/$workspace_id/settings/access/users/$user_id/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthWorkspacesWorkspaceidMaintenancesMaintenanceidDevicesDeviceidIndexRoute =
  AuthWorkspacesWorkspaceidMaintenancesMaintenanceidDevicesDeviceidIndexImport.update(
    {
      id: '/workspaces/$workspace_id/maintenances/$maintenance_id/devices/$device_id/',
      path: '/workspaces/$workspace_id/maintenances/$maintenance_id/devices/$device_id/',
      getParentRoute: () => AuthRoute,
    } as any,
  )

const AuthWorkspacesWorkspaceidDevicesDeviceidPartsPartidIndexRoute =
  AuthWorkspacesWorkspaceidDevicesDeviceidPartsPartidIndexImport.update({
    id: '/workspaces/$workspace_id/devices/$device_id/parts/$part_id/',
    path: '/workspaces/$workspace_id/devices/$device_id/parts/$part_id/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthWorkspacesWorkspaceidDeploymentsDeploymentidUsersUseridIndexRoute =
  AuthWorkspacesWorkspaceidDeploymentsDeploymentidUsersUseridIndexImport.update(
    {
      id: '/workspaces/$workspace_id/deployments/$deployment_id/users/$user_id/',
      path: '/workspaces/$workspace_id/deployments/$deployment_id/users/$user_id/',
      getParentRoute: () => AuthRoute,
    } as any,
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutImport
      parentRoute: typeof rootRoute
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyImport
      parentRoute: typeof rootRoute
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterImport
      parentRoute: typeof rootRoute
    }
    '/terms-trial': {
      id: '/terms-trial'
      path: '/terms-trial'
      fullPath: '/terms-trial'
      preLoaderRoute: typeof TermsTrialImport
      parentRoute: typeof rootRoute
    }
    '/_auth/academy': {
      id: '/_auth/academy'
      path: '/academy'
      fullPath: '/academy'
      preLoaderRoute: typeof AuthAcademyImport
      parentRoute: typeof AuthImport
    }
    '/_auth/end-of-trial': {
      id: '/_auth/end-of-trial'
      path: '/end-of-trial'
      fullPath: '/end-of-trial'
      preLoaderRoute: typeof AuthEndOfTrialImport
      parentRoute: typeof AuthImport
    }
    '/_auth/welcome': {
      id: '/_auth/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof AuthWelcomeImport
      parentRoute: typeof AuthImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/account/profile': {
      id: '/_auth/account/profile'
      path: '/account/profile'
      fullPath: '/account/profile'
      preLoaderRoute: typeof AuthAccountProfileImport
      parentRoute: typeof AuthImport
    }
    '/account/password/request': {
      id: '/account/password/request'
      path: '/account/password/request'
      fullPath: '/account/password/request'
      preLoaderRoute: typeof AccountPasswordRequestImport
      parentRoute: typeof rootRoute
    }
    '/account/verify/complete-invite': {
      id: '/account/verify/complete-invite'
      path: '/account/verify/complete-invite'
      fullPath: '/account/verify/complete-invite'
      preLoaderRoute: typeof AccountVerifyCompleteInviteImport
      parentRoute: typeof rootRoute
    }
    '/account/verify/complete-signup': {
      id: '/account/verify/complete-signup'
      path: '/account/verify/complete-signup'
      fullPath: '/account/verify/complete-signup'
      preLoaderRoute: typeof AccountVerifyCompleteSignupImport
      parentRoute: typeof rootRoute
    }
    '/_auth/workspaces/$workspace_id/device-insights': {
      id: '/_auth/workspaces/$workspace_id/device-insights'
      path: '/workspaces/$workspace_id/device-insights'
      fullPath: '/workspaces/$workspace_id/device-insights'
      preLoaderRoute: typeof AuthWorkspacesWorkspaceidDeviceInsightsRouteImport
      parentRoute: typeof AuthImport
    }
    '/_auth/account/password/reset': {
      id: '/_auth/account/password/reset'
      path: '/account/password/reset'
      fullPath: '/account/password/reset'
      preLoaderRoute: typeof AuthAccountPasswordResetImport
      parentRoute: typeof AuthImport
    }
    '/_auth/account/password/set': {
      id: '/_auth/account/password/set'
      path: '/account/password/set'
      fullPath: '/account/password/set'
      preLoaderRoute: typeof AuthAccountPasswordSetImport
      parentRoute: typeof AuthImport
    }
    '/_auth/workspaces/$workspace_id/customer-workspaces': {
      id: '/_auth/workspaces/$workspace_id/customer-workspaces'
      path: '/workspaces/$workspace_id/customer-workspaces'
      fullPath: '/workspaces/$workspace_id/customer-workspaces'
      preLoaderRoute: typeof AuthWorkspacesWorkspaceidCustomerWorkspacesImport
      parentRoute: typeof AuthImport
    }
    '/_auth/workspaces/$workspace_id/overview': {
      id: '/_auth/workspaces/$workspace_id/overview'
      path: '/workspaces/$workspace_id/overview'
      fullPath: '/workspaces/$workspace_id/overview'
      preLoaderRoute: typeof AuthWorkspacesWorkspaceidOverviewImport
      parentRoute: typeof AuthImport
    }
    '/account/verify/$type/$token': {
      id: '/account/verify/$type/$token'
      path: '/account/verify/$type/$token'
      fullPath: '/account/verify/$type/$token'
      preLoaderRoute: typeof AccountVerifyTypeTokenImport
      parentRoute: typeof rootRoute
    }
    '/_auth/workspaces/$workspace_id/': {
      id: '/_auth/workspaces/$workspace_id/'
      path: '/workspaces/$workspace_id'
      fullPath: '/workspaces/$workspace_id'
      preLoaderRoute: typeof AuthWorkspacesWorkspaceidIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/workspaces/$workspace_id/cases/type': {
      id: '/_auth/workspaces/$workspace_id/cases/type'
      path: '/workspaces/$workspace_id/cases/type'
      fullPath: '/workspaces/$workspace_id/cases/type'
      preLoaderRoute: typeof AuthWorkspacesWorkspaceidCasesTypeRouteImport
      parentRoute: typeof AuthImport
    }
    '/_auth/workspaces/$workspace_id/maintenances/type': {
      id: '/_auth/workspaces/$workspace_id/maintenances/type'
      path: '/workspaces/$workspace_id/maintenances/type'
      fullPath: '/workspaces/$workspace_id/maintenances/type'
      preLoaderRoute: typeof AuthWorkspacesWorkspaceidMaintenancesTypeRouteImport
      parentRoute: typeof AuthImport
    }
    '/_auth/workspaces/$workspace_id/settings/custom-inventory': {
      id: '/_auth/workspaces/$workspace_id/settings/custom-inventory'
      path: '/workspaces/$workspace_id/settings/custom-inventory'
      fullPath: '/workspaces/$workspace_id/settings/custom-inventory'
      preLoaderRoute: typeof AuthWorkspacesWorkspaceidSettingsCustomInventoryRouteImport
      parentRoute: typeof AuthImport
    }
    '/_auth/workspaces/$workspace_id/settings/tags': {
      id: '/_auth/workspaces/$workspace_id/settings/tags'
      path: '/workspaces/$workspace_id/settings/tags'
      fullPath: '/workspaces/$workspace_id/settings/tags'
      preLoaderRoute: typeof AuthWorkspacesWorkspaceidSettingsTagsRouteImport
      parentRoute: typeof AuthImport
    }
    '/_auth/workspaces/$workspace_id/inventory/activities': {
      id: '/_auth/workspaces/$workspace_id/inventory/activities'
      path: '/workspaces/$workspace_id/inventory/activities'
      fullPath: '/workspaces/$workspace_id/inventory/activities'
      preLoaderRoute: typeof AuthWorkspacesWorkspaceidInventoryActivitiesImport
      parentRoute: typeof AuthImport
    }
    '/_auth/workspaces/$workspace_id/inventory/assembled': {
      id: '/_auth/workspaces/$workspace_id/inventory/assembled'
      path: '/workspaces/$workspace_id/inventory/assembled'
      fullPath: '/workspaces/$workspace_id/inventory/assembled'
      preLoaderRoute: typeof AuthWorkspacesWorkspaceidInventoryAssembledImport
      parentRoute: typeof AuthImport
    }
    '/_auth/workspaces/$workspace_id/inventory/constraints': {
      id: '/_auth/workspaces/$workspace_id/inventory/constraints'
      path: '/workspaces/$workspace_id/inventory/constraints'
      fullPath: '/workspaces/$workspace_id/inventory/constraints'
      preLoaderRoute: typeof AuthWorkspacesWorkspaceidInventoryConstraintsImport
      parentRoute: typeof AuthImport
    }
    '/_auth/workspaces/$workspace_id/settings/details': {
      id: '/_auth/workspaces/$workspace_id/settings/details'
      path: '/workspaces/$workspace_id/settings/details'
      fullPath: '/workspaces/$workspace_id/settings/details'
      preLoaderRoute: typeof AuthWorkspacesWorkspaceidSettingsDetailsImport
      parentRoute: typeof AuthImport
    }
    '/_auth/workspaces/$workspace_id/settings/profile': {
      id: '/_auth/workspaces/$workspace_id/settings/profile'
      path: '/workspaces/$workspace_id/settings/profile'
      fullPath: '/workspaces/$workspace_id/settings/profile'
      preLoaderRoute: typeof AuthWorkspacesWorkspaceidSettingsProfileImport
      parentRoute: typeof AuthImport
    }
    '/_auth/workspaces/$workspace_id/cases/': {
      id: '/_auth/workspaces/$workspace_id/cases/'
      path: '/workspaces/$workspace_id/cases'
      fullPath: '/workspaces/$workspace_id/cases'
      preLoaderRoute: typeof AuthWorkspacesWorkspaceidCasesIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/workspaces/$workspace_id/checklist-templates/': {
      id: '/_auth/workspaces/$workspace_id/checklist-templates/'
      path: '/workspaces/$workspace_id/checklist-templates'
      fullPath: '/workspaces/$workspace_id/checklist-templates'
      preLoaderRoute: typeof AuthWorkspacesWorkspaceidChecklistTemplatesIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/workspaces/$workspace_id/deployments/': {
      id: '/_auth/workspaces/$workspace_id/deployments/'
      path: '/workspaces/$workspace_id/deployments'
      fullPath: '/workspaces/$workspace_id/deployments'
      preLoaderRoute: typeof AuthWorkspacesWorkspaceidDeploymentsIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/workspaces/$workspace_id/devices/': {
      id: '/_auth/workspaces/$workspace_id/devices/'
      path: '/workspaces/$workspace_id/devices'
      fullPath: '/workspaces/$workspace_id/devices'
      preLoaderRoute: typeof AuthWorkspacesWorkspaceidDevicesIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/workspaces/$workspace_id/maintenance-strategies/': {
      id: '/_auth/workspaces/$workspace_id/maintenance-strategies/'
      path: '/workspaces/$workspace_id/maintenance-strategies'
      fullPath: '/workspaces/$workspace_id/maintenance-strategies'
      preLoaderRoute: typeof AuthWorkspacesWorkspaceidMaintenanceStrategiesIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/workspaces/$workspace_id/maintenances/': {
      id: '/_auth/workspaces/$workspace_id/maintenances/'
      path: '/workspaces/$workspace_id/maintenances'
      fullPath: '/workspaces/$workspace_id/maintenances'
      preLoaderRoute: typeof AuthWorkspacesWorkspaceidMaintenancesIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/workspaces/$workspace_id/cases/$case_id/': {
      id: '/_auth/workspaces/$workspace_id/cases/$case_id/'
      path: '/workspaces/$workspace_id/cases/$case_id'
      fullPath: '/workspaces/$workspace_id/cases/$case_id'
      preLoaderRoute: typeof AuthWorkspacesWorkspaceidCasesCaseidIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/workspaces/$workspace_id/checklist-templates/$checklist_template_id/': {
      id: '/_auth/workspaces/$workspace_id/checklist-templates/$checklist_template_id/'
      path: '/workspaces/$workspace_id/checklist-templates/$checklist_template_id'
      fullPath: '/workspaces/$workspace_id/checklist-templates/$checklist_template_id'
      preLoaderRoute: typeof AuthWorkspacesWorkspaceidChecklistTemplatesChecklisttemplateidIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/workspaces/$workspace_id/deployments/$deployment_id/': {
      id: '/_auth/workspaces/$workspace_id/deployments/$deployment_id/'
      path: '/workspaces/$workspace_id/deployments/$deployment_id'
      fullPath: '/workspaces/$workspace_id/deployments/$deployment_id'
      preLoaderRoute: typeof AuthWorkspacesWorkspaceidDeploymentsDeploymentidIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/workspaces/$workspace_id/device-insights/$type/': {
      id: '/_auth/workspaces/$workspace_id/device-insights/$type/'
      path: '/$type'
      fullPath: '/workspaces/$workspace_id/device-insights/$type'
      preLoaderRoute: typeof AuthWorkspacesWorkspaceidDeviceInsightsTypeIndexImport
      parentRoute: typeof AuthWorkspacesWorkspaceidDeviceInsightsRouteImport
    }
    '/_auth/workspaces/$workspace_id/devices/$device_id/': {
      id: '/_auth/workspaces/$workspace_id/devices/$device_id/'
      path: '/workspaces/$workspace_id/devices/$device_id'
      fullPath: '/workspaces/$workspace_id/devices/$device_id'
      preLoaderRoute: typeof AuthWorkspacesWorkspaceidDevicesDeviceidIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/workspaces/$workspace_id/inventory/parts/': {
      id: '/_auth/workspaces/$workspace_id/inventory/parts/'
      path: '/workspaces/$workspace_id/inventory/parts'
      fullPath: '/workspaces/$workspace_id/inventory/parts'
      preLoaderRoute: typeof AuthWorkspacesWorkspaceidInventoryPartsIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/workspaces/$workspace_id/maintenance-strategies/$maintenance_strategy_id/': {
      id: '/_auth/workspaces/$workspace_id/maintenance-strategies/$maintenance_strategy_id/'
      path: '/workspaces/$workspace_id/maintenance-strategies/$maintenance_strategy_id'
      fullPath: '/workspaces/$workspace_id/maintenance-strategies/$maintenance_strategy_id'
      preLoaderRoute: typeof AuthWorkspacesWorkspaceidMaintenanceStrategiesMaintenancestrategyidIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/workspaces/$workspace_id/maintenances/$maintenance_id/': {
      id: '/_auth/workspaces/$workspace_id/maintenances/$maintenance_id/'
      path: '/workspaces/$workspace_id/maintenances/$maintenance_id'
      fullPath: '/workspaces/$workspace_id/maintenances/$maintenance_id'
      preLoaderRoute: typeof AuthWorkspacesWorkspaceidMaintenancesMaintenanceidIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/workspaces/$workspace_id/settings/access/': {
      id: '/_auth/workspaces/$workspace_id/settings/access/'
      path: '/workspaces/$workspace_id/settings/access'
      fullPath: '/workspaces/$workspace_id/settings/access'
      preLoaderRoute: typeof AuthWorkspacesWorkspaceidSettingsAccessIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/workspaces/$workspace_id/cases/type/$type/': {
      id: '/_auth/workspaces/$workspace_id/cases/type/$type/'
      path: '/$type'
      fullPath: '/workspaces/$workspace_id/cases/type/$type'
      preLoaderRoute: typeof AuthWorkspacesWorkspaceidCasesTypeTypeIndexImport
      parentRoute: typeof AuthWorkspacesWorkspaceidCasesTypeRouteImport
    }
    '/_auth/workspaces/$workspace_id/inventory/parts/$part_id/': {
      id: '/_auth/workspaces/$workspace_id/inventory/parts/$part_id/'
      path: '/workspaces/$workspace_id/inventory/parts/$part_id'
      fullPath: '/workspaces/$workspace_id/inventory/parts/$part_id'
      preLoaderRoute: typeof AuthWorkspacesWorkspaceidInventoryPartsPartidIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/workspaces/$workspace_id/maintenances/type/$type/': {
      id: '/_auth/workspaces/$workspace_id/maintenances/type/$type/'
      path: '/$type'
      fullPath: '/workspaces/$workspace_id/maintenances/type/$type'
      preLoaderRoute: typeof AuthWorkspacesWorkspaceidMaintenancesTypeTypeIndexImport
      parentRoute: typeof AuthWorkspacesWorkspaceidMaintenancesTypeRouteImport
    }
    '/_auth/workspaces/$workspace_id/settings/custom-inventory/$type/': {
      id: '/_auth/workspaces/$workspace_id/settings/custom-inventory/$type/'
      path: '/$type'
      fullPath: '/workspaces/$workspace_id/settings/custom-inventory/$type'
      preLoaderRoute: typeof AuthWorkspacesWorkspaceidSettingsCustomInventoryTypeIndexImport
      parentRoute: typeof AuthWorkspacesWorkspaceidSettingsCustomInventoryRouteImport
    }
    '/_auth/workspaces/$workspace_id/settings/tags/$type/': {
      id: '/_auth/workspaces/$workspace_id/settings/tags/$type/'
      path: '/$type'
      fullPath: '/workspaces/$workspace_id/settings/tags/$type'
      preLoaderRoute: typeof AuthWorkspacesWorkspaceidSettingsTagsTypeIndexImport
      parentRoute: typeof AuthWorkspacesWorkspaceidSettingsTagsRouteImport
    }
    '/_auth/workspaces/$workspace_id/deployments/$deployment_id/users/$user_id/': {
      id: '/_auth/workspaces/$workspace_id/deployments/$deployment_id/users/$user_id/'
      path: '/workspaces/$workspace_id/deployments/$deployment_id/users/$user_id'
      fullPath: '/workspaces/$workspace_id/deployments/$deployment_id/users/$user_id'
      preLoaderRoute: typeof AuthWorkspacesWorkspaceidDeploymentsDeploymentidUsersUseridIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/workspaces/$workspace_id/devices/$device_id/parts/$part_id/': {
      id: '/_auth/workspaces/$workspace_id/devices/$device_id/parts/$part_id/'
      path: '/workspaces/$workspace_id/devices/$device_id/parts/$part_id'
      fullPath: '/workspaces/$workspace_id/devices/$device_id/parts/$part_id'
      preLoaderRoute: typeof AuthWorkspacesWorkspaceidDevicesDeviceidPartsPartidIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/workspaces/$workspace_id/maintenances/$maintenance_id/devices/$device_id/': {
      id: '/_auth/workspaces/$workspace_id/maintenances/$maintenance_id/devices/$device_id/'
      path: '/workspaces/$workspace_id/maintenances/$maintenance_id/devices/$device_id'
      fullPath: '/workspaces/$workspace_id/maintenances/$maintenance_id/devices/$device_id'
      preLoaderRoute: typeof AuthWorkspacesWorkspaceidMaintenancesMaintenanceidDevicesDeviceidIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/workspaces/$workspace_id/settings/access/users/$user_id/': {
      id: '/_auth/workspaces/$workspace_id/settings/access/users/$user_id/'
      path: '/workspaces/$workspace_id/settings/access/users/$user_id'
      fullPath: '/workspaces/$workspace_id/settings/access/users/$user_id'
      preLoaderRoute: typeof AuthWorkspacesWorkspaceidSettingsAccessUsersUseridIndexImport
      parentRoute: typeof AuthImport
    }
  }
}

// Create and export the route tree

interface AuthWorkspacesWorkspaceidDeviceInsightsRouteRouteChildren {
  AuthWorkspacesWorkspaceidDeviceInsightsTypeIndexRoute: typeof AuthWorkspacesWorkspaceidDeviceInsightsTypeIndexRoute
}

const AuthWorkspacesWorkspaceidDeviceInsightsRouteRouteChildren: AuthWorkspacesWorkspaceidDeviceInsightsRouteRouteChildren =
  {
    AuthWorkspacesWorkspaceidDeviceInsightsTypeIndexRoute:
      AuthWorkspacesWorkspaceidDeviceInsightsTypeIndexRoute,
  }

const AuthWorkspacesWorkspaceidDeviceInsightsRouteRouteWithChildren =
  AuthWorkspacesWorkspaceidDeviceInsightsRouteRoute._addFileChildren(
    AuthWorkspacesWorkspaceidDeviceInsightsRouteRouteChildren,
  )

interface AuthWorkspacesWorkspaceidCasesTypeRouteRouteChildren {
  AuthWorkspacesWorkspaceidCasesTypeTypeIndexRoute: typeof AuthWorkspacesWorkspaceidCasesTypeTypeIndexRoute
}

const AuthWorkspacesWorkspaceidCasesTypeRouteRouteChildren: AuthWorkspacesWorkspaceidCasesTypeRouteRouteChildren =
  {
    AuthWorkspacesWorkspaceidCasesTypeTypeIndexRoute:
      AuthWorkspacesWorkspaceidCasesTypeTypeIndexRoute,
  }

const AuthWorkspacesWorkspaceidCasesTypeRouteRouteWithChildren =
  AuthWorkspacesWorkspaceidCasesTypeRouteRoute._addFileChildren(
    AuthWorkspacesWorkspaceidCasesTypeRouteRouteChildren,
  )

interface AuthWorkspacesWorkspaceidMaintenancesTypeRouteRouteChildren {
  AuthWorkspacesWorkspaceidMaintenancesTypeTypeIndexRoute: typeof AuthWorkspacesWorkspaceidMaintenancesTypeTypeIndexRoute
}

const AuthWorkspacesWorkspaceidMaintenancesTypeRouteRouteChildren: AuthWorkspacesWorkspaceidMaintenancesTypeRouteRouteChildren =
  {
    AuthWorkspacesWorkspaceidMaintenancesTypeTypeIndexRoute:
      AuthWorkspacesWorkspaceidMaintenancesTypeTypeIndexRoute,
  }

const AuthWorkspacesWorkspaceidMaintenancesTypeRouteRouteWithChildren =
  AuthWorkspacesWorkspaceidMaintenancesTypeRouteRoute._addFileChildren(
    AuthWorkspacesWorkspaceidMaintenancesTypeRouteRouteChildren,
  )

interface AuthWorkspacesWorkspaceidSettingsCustomInventoryRouteRouteChildren {
  AuthWorkspacesWorkspaceidSettingsCustomInventoryTypeIndexRoute: typeof AuthWorkspacesWorkspaceidSettingsCustomInventoryTypeIndexRoute
}

const AuthWorkspacesWorkspaceidSettingsCustomInventoryRouteRouteChildren: AuthWorkspacesWorkspaceidSettingsCustomInventoryRouteRouteChildren =
  {
    AuthWorkspacesWorkspaceidSettingsCustomInventoryTypeIndexRoute:
      AuthWorkspacesWorkspaceidSettingsCustomInventoryTypeIndexRoute,
  }

const AuthWorkspacesWorkspaceidSettingsCustomInventoryRouteRouteWithChildren =
  AuthWorkspacesWorkspaceidSettingsCustomInventoryRouteRoute._addFileChildren(
    AuthWorkspacesWorkspaceidSettingsCustomInventoryRouteRouteChildren,
  )

interface AuthWorkspacesWorkspaceidSettingsTagsRouteRouteChildren {
  AuthWorkspacesWorkspaceidSettingsTagsTypeIndexRoute: typeof AuthWorkspacesWorkspaceidSettingsTagsTypeIndexRoute
}

const AuthWorkspacesWorkspaceidSettingsTagsRouteRouteChildren: AuthWorkspacesWorkspaceidSettingsTagsRouteRouteChildren =
  {
    AuthWorkspacesWorkspaceidSettingsTagsTypeIndexRoute:
      AuthWorkspacesWorkspaceidSettingsTagsTypeIndexRoute,
  }

const AuthWorkspacesWorkspaceidSettingsTagsRouteRouteWithChildren =
  AuthWorkspacesWorkspaceidSettingsTagsRouteRoute._addFileChildren(
    AuthWorkspacesWorkspaceidSettingsTagsRouteRouteChildren,
  )

interface AuthRouteChildren {
  AuthAcademyRoute: typeof AuthAcademyRoute
  AuthEndOfTrialRoute: typeof AuthEndOfTrialRoute
  AuthWelcomeRoute: typeof AuthWelcomeRoute
  AuthIndexRoute: typeof AuthIndexRoute
  AuthAccountProfileRoute: typeof AuthAccountProfileRoute
  AuthWorkspacesWorkspaceidDeviceInsightsRouteRoute: typeof AuthWorkspacesWorkspaceidDeviceInsightsRouteRouteWithChildren
  AuthAccountPasswordResetRoute: typeof AuthAccountPasswordResetRoute
  AuthAccountPasswordSetRoute: typeof AuthAccountPasswordSetRoute
  AuthWorkspacesWorkspaceidCustomerWorkspacesRoute: typeof AuthWorkspacesWorkspaceidCustomerWorkspacesRoute
  AuthWorkspacesWorkspaceidOverviewRoute: typeof AuthWorkspacesWorkspaceidOverviewRoute
  AuthWorkspacesWorkspaceidIndexRoute: typeof AuthWorkspacesWorkspaceidIndexRoute
  AuthWorkspacesWorkspaceidCasesTypeRouteRoute: typeof AuthWorkspacesWorkspaceidCasesTypeRouteRouteWithChildren
  AuthWorkspacesWorkspaceidMaintenancesTypeRouteRoute: typeof AuthWorkspacesWorkspaceidMaintenancesTypeRouteRouteWithChildren
  AuthWorkspacesWorkspaceidSettingsCustomInventoryRouteRoute: typeof AuthWorkspacesWorkspaceidSettingsCustomInventoryRouteRouteWithChildren
  AuthWorkspacesWorkspaceidSettingsTagsRouteRoute: typeof AuthWorkspacesWorkspaceidSettingsTagsRouteRouteWithChildren
  AuthWorkspacesWorkspaceidInventoryActivitiesRoute: typeof AuthWorkspacesWorkspaceidInventoryActivitiesRoute
  AuthWorkspacesWorkspaceidInventoryAssembledRoute: typeof AuthWorkspacesWorkspaceidInventoryAssembledRoute
  AuthWorkspacesWorkspaceidInventoryConstraintsRoute: typeof AuthWorkspacesWorkspaceidInventoryConstraintsRoute
  AuthWorkspacesWorkspaceidSettingsDetailsRoute: typeof AuthWorkspacesWorkspaceidSettingsDetailsRoute
  AuthWorkspacesWorkspaceidSettingsProfileRoute: typeof AuthWorkspacesWorkspaceidSettingsProfileRoute
  AuthWorkspacesWorkspaceidCasesIndexRoute: typeof AuthWorkspacesWorkspaceidCasesIndexRoute
  AuthWorkspacesWorkspaceidChecklistTemplatesIndexRoute: typeof AuthWorkspacesWorkspaceidChecklistTemplatesIndexRoute
  AuthWorkspacesWorkspaceidDeploymentsIndexRoute: typeof AuthWorkspacesWorkspaceidDeploymentsIndexRoute
  AuthWorkspacesWorkspaceidDevicesIndexRoute: typeof AuthWorkspacesWorkspaceidDevicesIndexRoute
  AuthWorkspacesWorkspaceidMaintenanceStrategiesIndexRoute: typeof AuthWorkspacesWorkspaceidMaintenanceStrategiesIndexRoute
  AuthWorkspacesWorkspaceidMaintenancesIndexRoute: typeof AuthWorkspacesWorkspaceidMaintenancesIndexRoute
  AuthWorkspacesWorkspaceidCasesCaseidIndexRoute: typeof AuthWorkspacesWorkspaceidCasesCaseidIndexRoute
  AuthWorkspacesWorkspaceidChecklistTemplatesChecklisttemplateidIndexRoute: typeof AuthWorkspacesWorkspaceidChecklistTemplatesChecklisttemplateidIndexRoute
  AuthWorkspacesWorkspaceidDeploymentsDeploymentidIndexRoute: typeof AuthWorkspacesWorkspaceidDeploymentsDeploymentidIndexRoute
  AuthWorkspacesWorkspaceidDevicesDeviceidIndexRoute: typeof AuthWorkspacesWorkspaceidDevicesDeviceidIndexRoute
  AuthWorkspacesWorkspaceidInventoryPartsIndexRoute: typeof AuthWorkspacesWorkspaceidInventoryPartsIndexRoute
  AuthWorkspacesWorkspaceidMaintenanceStrategiesMaintenancestrategyidIndexRoute: typeof AuthWorkspacesWorkspaceidMaintenanceStrategiesMaintenancestrategyidIndexRoute
  AuthWorkspacesWorkspaceidMaintenancesMaintenanceidIndexRoute: typeof AuthWorkspacesWorkspaceidMaintenancesMaintenanceidIndexRoute
  AuthWorkspacesWorkspaceidSettingsAccessIndexRoute: typeof AuthWorkspacesWorkspaceidSettingsAccessIndexRoute
  AuthWorkspacesWorkspaceidInventoryPartsPartidIndexRoute: typeof AuthWorkspacesWorkspaceidInventoryPartsPartidIndexRoute
  AuthWorkspacesWorkspaceidDeploymentsDeploymentidUsersUseridIndexRoute: typeof AuthWorkspacesWorkspaceidDeploymentsDeploymentidUsersUseridIndexRoute
  AuthWorkspacesWorkspaceidDevicesDeviceidPartsPartidIndexRoute: typeof AuthWorkspacesWorkspaceidDevicesDeviceidPartsPartidIndexRoute
  AuthWorkspacesWorkspaceidMaintenancesMaintenanceidDevicesDeviceidIndexRoute: typeof AuthWorkspacesWorkspaceidMaintenancesMaintenanceidDevicesDeviceidIndexRoute
  AuthWorkspacesWorkspaceidSettingsAccessUsersUseridIndexRoute: typeof AuthWorkspacesWorkspaceidSettingsAccessUsersUseridIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAcademyRoute: AuthAcademyRoute,
  AuthEndOfTrialRoute: AuthEndOfTrialRoute,
  AuthWelcomeRoute: AuthWelcomeRoute,
  AuthIndexRoute: AuthIndexRoute,
  AuthAccountProfileRoute: AuthAccountProfileRoute,
  AuthWorkspacesWorkspaceidDeviceInsightsRouteRoute:
    AuthWorkspacesWorkspaceidDeviceInsightsRouteRouteWithChildren,
  AuthAccountPasswordResetRoute: AuthAccountPasswordResetRoute,
  AuthAccountPasswordSetRoute: AuthAccountPasswordSetRoute,
  AuthWorkspacesWorkspaceidCustomerWorkspacesRoute:
    AuthWorkspacesWorkspaceidCustomerWorkspacesRoute,
  AuthWorkspacesWorkspaceidOverviewRoute:
    AuthWorkspacesWorkspaceidOverviewRoute,
  AuthWorkspacesWorkspaceidIndexRoute: AuthWorkspacesWorkspaceidIndexRoute,
  AuthWorkspacesWorkspaceidCasesTypeRouteRoute:
    AuthWorkspacesWorkspaceidCasesTypeRouteRouteWithChildren,
  AuthWorkspacesWorkspaceidMaintenancesTypeRouteRoute:
    AuthWorkspacesWorkspaceidMaintenancesTypeRouteRouteWithChildren,
  AuthWorkspacesWorkspaceidSettingsCustomInventoryRouteRoute:
    AuthWorkspacesWorkspaceidSettingsCustomInventoryRouteRouteWithChildren,
  AuthWorkspacesWorkspaceidSettingsTagsRouteRoute:
    AuthWorkspacesWorkspaceidSettingsTagsRouteRouteWithChildren,
  AuthWorkspacesWorkspaceidInventoryActivitiesRoute:
    AuthWorkspacesWorkspaceidInventoryActivitiesRoute,
  AuthWorkspacesWorkspaceidInventoryAssembledRoute:
    AuthWorkspacesWorkspaceidInventoryAssembledRoute,
  AuthWorkspacesWorkspaceidInventoryConstraintsRoute:
    AuthWorkspacesWorkspaceidInventoryConstraintsRoute,
  AuthWorkspacesWorkspaceidSettingsDetailsRoute:
    AuthWorkspacesWorkspaceidSettingsDetailsRoute,
  AuthWorkspacesWorkspaceidSettingsProfileRoute:
    AuthWorkspacesWorkspaceidSettingsProfileRoute,
  AuthWorkspacesWorkspaceidCasesIndexRoute:
    AuthWorkspacesWorkspaceidCasesIndexRoute,
  AuthWorkspacesWorkspaceidChecklistTemplatesIndexRoute:
    AuthWorkspacesWorkspaceidChecklistTemplatesIndexRoute,
  AuthWorkspacesWorkspaceidDeploymentsIndexRoute:
    AuthWorkspacesWorkspaceidDeploymentsIndexRoute,
  AuthWorkspacesWorkspaceidDevicesIndexRoute:
    AuthWorkspacesWorkspaceidDevicesIndexRoute,
  AuthWorkspacesWorkspaceidMaintenanceStrategiesIndexRoute:
    AuthWorkspacesWorkspaceidMaintenanceStrategiesIndexRoute,
  AuthWorkspacesWorkspaceidMaintenancesIndexRoute:
    AuthWorkspacesWorkspaceidMaintenancesIndexRoute,
  AuthWorkspacesWorkspaceidCasesCaseidIndexRoute:
    AuthWorkspacesWorkspaceidCasesCaseidIndexRoute,
  AuthWorkspacesWorkspaceidChecklistTemplatesChecklisttemplateidIndexRoute:
    AuthWorkspacesWorkspaceidChecklistTemplatesChecklisttemplateidIndexRoute,
  AuthWorkspacesWorkspaceidDeploymentsDeploymentidIndexRoute:
    AuthWorkspacesWorkspaceidDeploymentsDeploymentidIndexRoute,
  AuthWorkspacesWorkspaceidDevicesDeviceidIndexRoute:
    AuthWorkspacesWorkspaceidDevicesDeviceidIndexRoute,
  AuthWorkspacesWorkspaceidInventoryPartsIndexRoute:
    AuthWorkspacesWorkspaceidInventoryPartsIndexRoute,
  AuthWorkspacesWorkspaceidMaintenanceStrategiesMaintenancestrategyidIndexRoute:
    AuthWorkspacesWorkspaceidMaintenanceStrategiesMaintenancestrategyidIndexRoute,
  AuthWorkspacesWorkspaceidMaintenancesMaintenanceidIndexRoute:
    AuthWorkspacesWorkspaceidMaintenancesMaintenanceidIndexRoute,
  AuthWorkspacesWorkspaceidSettingsAccessIndexRoute:
    AuthWorkspacesWorkspaceidSettingsAccessIndexRoute,
  AuthWorkspacesWorkspaceidInventoryPartsPartidIndexRoute:
    AuthWorkspacesWorkspaceidInventoryPartsPartidIndexRoute,
  AuthWorkspacesWorkspaceidDeploymentsDeploymentidUsersUseridIndexRoute:
    AuthWorkspacesWorkspaceidDeploymentsDeploymentidUsersUseridIndexRoute,
  AuthWorkspacesWorkspaceidDevicesDeviceidPartsPartidIndexRoute:
    AuthWorkspacesWorkspaceidDevicesDeviceidPartsPartidIndexRoute,
  AuthWorkspacesWorkspaceidMaintenancesMaintenanceidDevicesDeviceidIndexRoute:
    AuthWorkspacesWorkspaceidMaintenancesMaintenanceidDevicesDeviceidIndexRoute,
  AuthWorkspacesWorkspaceidSettingsAccessUsersUseridIndexRoute:
    AuthWorkspacesWorkspaceidSettingsAccessUsersUseridIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

export interface FileRoutesByFullPath {
  '': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/terms-trial': typeof TermsTrialRoute
  '/academy': typeof AuthAcademyRoute
  '/end-of-trial': typeof AuthEndOfTrialRoute
  '/welcome': typeof AuthWelcomeRoute
  '/': typeof AuthIndexRoute
  '/account/profile': typeof AuthAccountProfileRoute
  '/account/password/request': typeof AccountPasswordRequestRoute
  '/account/verify/complete-invite': typeof AccountVerifyCompleteInviteRoute
  '/account/verify/complete-signup': typeof AccountVerifyCompleteSignupRoute
  '/workspaces/$workspace_id/device-insights': typeof AuthWorkspacesWorkspaceidDeviceInsightsRouteRouteWithChildren
  '/account/password/reset': typeof AuthAccountPasswordResetRoute
  '/account/password/set': typeof AuthAccountPasswordSetRoute
  '/workspaces/$workspace_id/customer-workspaces': typeof AuthWorkspacesWorkspaceidCustomerWorkspacesRoute
  '/workspaces/$workspace_id/overview': typeof AuthWorkspacesWorkspaceidOverviewRoute
  '/account/verify/$type/$token': typeof AccountVerifyTypeTokenRoute
  '/workspaces/$workspace_id': typeof AuthWorkspacesWorkspaceidIndexRoute
  '/workspaces/$workspace_id/cases/type': typeof AuthWorkspacesWorkspaceidCasesTypeRouteRouteWithChildren
  '/workspaces/$workspace_id/maintenances/type': typeof AuthWorkspacesWorkspaceidMaintenancesTypeRouteRouteWithChildren
  '/workspaces/$workspace_id/settings/custom-inventory': typeof AuthWorkspacesWorkspaceidSettingsCustomInventoryRouteRouteWithChildren
  '/workspaces/$workspace_id/settings/tags': typeof AuthWorkspacesWorkspaceidSettingsTagsRouteRouteWithChildren
  '/workspaces/$workspace_id/inventory/activities': typeof AuthWorkspacesWorkspaceidInventoryActivitiesRoute
  '/workspaces/$workspace_id/inventory/assembled': typeof AuthWorkspacesWorkspaceidInventoryAssembledRoute
  '/workspaces/$workspace_id/inventory/constraints': typeof AuthWorkspacesWorkspaceidInventoryConstraintsRoute
  '/workspaces/$workspace_id/settings/details': typeof AuthWorkspacesWorkspaceidSettingsDetailsRoute
  '/workspaces/$workspace_id/settings/profile': typeof AuthWorkspacesWorkspaceidSettingsProfileRoute
  '/workspaces/$workspace_id/cases': typeof AuthWorkspacesWorkspaceidCasesIndexRoute
  '/workspaces/$workspace_id/checklist-templates': typeof AuthWorkspacesWorkspaceidChecklistTemplatesIndexRoute
  '/workspaces/$workspace_id/deployments': typeof AuthWorkspacesWorkspaceidDeploymentsIndexRoute
  '/workspaces/$workspace_id/devices': typeof AuthWorkspacesWorkspaceidDevicesIndexRoute
  '/workspaces/$workspace_id/maintenance-strategies': typeof AuthWorkspacesWorkspaceidMaintenanceStrategiesIndexRoute
  '/workspaces/$workspace_id/maintenances': typeof AuthWorkspacesWorkspaceidMaintenancesIndexRoute
  '/workspaces/$workspace_id/cases/$case_id': typeof AuthWorkspacesWorkspaceidCasesCaseidIndexRoute
  '/workspaces/$workspace_id/checklist-templates/$checklist_template_id': typeof AuthWorkspacesWorkspaceidChecklistTemplatesChecklisttemplateidIndexRoute
  '/workspaces/$workspace_id/deployments/$deployment_id': typeof AuthWorkspacesWorkspaceidDeploymentsDeploymentidIndexRoute
  '/workspaces/$workspace_id/device-insights/$type': typeof AuthWorkspacesWorkspaceidDeviceInsightsTypeIndexRoute
  '/workspaces/$workspace_id/devices/$device_id': typeof AuthWorkspacesWorkspaceidDevicesDeviceidIndexRoute
  '/workspaces/$workspace_id/inventory/parts': typeof AuthWorkspacesWorkspaceidInventoryPartsIndexRoute
  '/workspaces/$workspace_id/maintenance-strategies/$maintenance_strategy_id': typeof AuthWorkspacesWorkspaceidMaintenanceStrategiesMaintenancestrategyidIndexRoute
  '/workspaces/$workspace_id/maintenances/$maintenance_id': typeof AuthWorkspacesWorkspaceidMaintenancesMaintenanceidIndexRoute
  '/workspaces/$workspace_id/settings/access': typeof AuthWorkspacesWorkspaceidSettingsAccessIndexRoute
  '/workspaces/$workspace_id/cases/type/$type': typeof AuthWorkspacesWorkspaceidCasesTypeTypeIndexRoute
  '/workspaces/$workspace_id/inventory/parts/$part_id': typeof AuthWorkspacesWorkspaceidInventoryPartsPartidIndexRoute
  '/workspaces/$workspace_id/maintenances/type/$type': typeof AuthWorkspacesWorkspaceidMaintenancesTypeTypeIndexRoute
  '/workspaces/$workspace_id/settings/custom-inventory/$type': typeof AuthWorkspacesWorkspaceidSettingsCustomInventoryTypeIndexRoute
  '/workspaces/$workspace_id/settings/tags/$type': typeof AuthWorkspacesWorkspaceidSettingsTagsTypeIndexRoute
  '/workspaces/$workspace_id/deployments/$deployment_id/users/$user_id': typeof AuthWorkspacesWorkspaceidDeploymentsDeploymentidUsersUseridIndexRoute
  '/workspaces/$workspace_id/devices/$device_id/parts/$part_id': typeof AuthWorkspacesWorkspaceidDevicesDeviceidPartsPartidIndexRoute
  '/workspaces/$workspace_id/maintenances/$maintenance_id/devices/$device_id': typeof AuthWorkspacesWorkspaceidMaintenancesMaintenanceidDevicesDeviceidIndexRoute
  '/workspaces/$workspace_id/settings/access/users/$user_id': typeof AuthWorkspacesWorkspaceidSettingsAccessUsersUseridIndexRoute
}

export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/terms-trial': typeof TermsTrialRoute
  '/academy': typeof AuthAcademyRoute
  '/end-of-trial': typeof AuthEndOfTrialRoute
  '/welcome': typeof AuthWelcomeRoute
  '/': typeof AuthIndexRoute
  '/account/profile': typeof AuthAccountProfileRoute
  '/account/password/request': typeof AccountPasswordRequestRoute
  '/account/verify/complete-invite': typeof AccountVerifyCompleteInviteRoute
  '/account/verify/complete-signup': typeof AccountVerifyCompleteSignupRoute
  '/workspaces/$workspace_id/device-insights': typeof AuthWorkspacesWorkspaceidDeviceInsightsRouteRouteWithChildren
  '/account/password/reset': typeof AuthAccountPasswordResetRoute
  '/account/password/set': typeof AuthAccountPasswordSetRoute
  '/workspaces/$workspace_id/customer-workspaces': typeof AuthWorkspacesWorkspaceidCustomerWorkspacesRoute
  '/workspaces/$workspace_id/overview': typeof AuthWorkspacesWorkspaceidOverviewRoute
  '/account/verify/$type/$token': typeof AccountVerifyTypeTokenRoute
  '/workspaces/$workspace_id': typeof AuthWorkspacesWorkspaceidIndexRoute
  '/workspaces/$workspace_id/cases/type': typeof AuthWorkspacesWorkspaceidCasesTypeRouteRouteWithChildren
  '/workspaces/$workspace_id/maintenances/type': typeof AuthWorkspacesWorkspaceidMaintenancesTypeRouteRouteWithChildren
  '/workspaces/$workspace_id/settings/custom-inventory': typeof AuthWorkspacesWorkspaceidSettingsCustomInventoryRouteRouteWithChildren
  '/workspaces/$workspace_id/settings/tags': typeof AuthWorkspacesWorkspaceidSettingsTagsRouteRouteWithChildren
  '/workspaces/$workspace_id/inventory/activities': typeof AuthWorkspacesWorkspaceidInventoryActivitiesRoute
  '/workspaces/$workspace_id/inventory/assembled': typeof AuthWorkspacesWorkspaceidInventoryAssembledRoute
  '/workspaces/$workspace_id/inventory/constraints': typeof AuthWorkspacesWorkspaceidInventoryConstraintsRoute
  '/workspaces/$workspace_id/settings/details': typeof AuthWorkspacesWorkspaceidSettingsDetailsRoute
  '/workspaces/$workspace_id/settings/profile': typeof AuthWorkspacesWorkspaceidSettingsProfileRoute
  '/workspaces/$workspace_id/cases': typeof AuthWorkspacesWorkspaceidCasesIndexRoute
  '/workspaces/$workspace_id/checklist-templates': typeof AuthWorkspacesWorkspaceidChecklistTemplatesIndexRoute
  '/workspaces/$workspace_id/deployments': typeof AuthWorkspacesWorkspaceidDeploymentsIndexRoute
  '/workspaces/$workspace_id/devices': typeof AuthWorkspacesWorkspaceidDevicesIndexRoute
  '/workspaces/$workspace_id/maintenance-strategies': typeof AuthWorkspacesWorkspaceidMaintenanceStrategiesIndexRoute
  '/workspaces/$workspace_id/maintenances': typeof AuthWorkspacesWorkspaceidMaintenancesIndexRoute
  '/workspaces/$workspace_id/cases/$case_id': typeof AuthWorkspacesWorkspaceidCasesCaseidIndexRoute
  '/workspaces/$workspace_id/checklist-templates/$checklist_template_id': typeof AuthWorkspacesWorkspaceidChecklistTemplatesChecklisttemplateidIndexRoute
  '/workspaces/$workspace_id/deployments/$deployment_id': typeof AuthWorkspacesWorkspaceidDeploymentsDeploymentidIndexRoute
  '/workspaces/$workspace_id/device-insights/$type': typeof AuthWorkspacesWorkspaceidDeviceInsightsTypeIndexRoute
  '/workspaces/$workspace_id/devices/$device_id': typeof AuthWorkspacesWorkspaceidDevicesDeviceidIndexRoute
  '/workspaces/$workspace_id/inventory/parts': typeof AuthWorkspacesWorkspaceidInventoryPartsIndexRoute
  '/workspaces/$workspace_id/maintenance-strategies/$maintenance_strategy_id': typeof AuthWorkspacesWorkspaceidMaintenanceStrategiesMaintenancestrategyidIndexRoute
  '/workspaces/$workspace_id/maintenances/$maintenance_id': typeof AuthWorkspacesWorkspaceidMaintenancesMaintenanceidIndexRoute
  '/workspaces/$workspace_id/settings/access': typeof AuthWorkspacesWorkspaceidSettingsAccessIndexRoute
  '/workspaces/$workspace_id/cases/type/$type': typeof AuthWorkspacesWorkspaceidCasesTypeTypeIndexRoute
  '/workspaces/$workspace_id/inventory/parts/$part_id': typeof AuthWorkspacesWorkspaceidInventoryPartsPartidIndexRoute
  '/workspaces/$workspace_id/maintenances/type/$type': typeof AuthWorkspacesWorkspaceidMaintenancesTypeTypeIndexRoute
  '/workspaces/$workspace_id/settings/custom-inventory/$type': typeof AuthWorkspacesWorkspaceidSettingsCustomInventoryTypeIndexRoute
  '/workspaces/$workspace_id/settings/tags/$type': typeof AuthWorkspacesWorkspaceidSettingsTagsTypeIndexRoute
  '/workspaces/$workspace_id/deployments/$deployment_id/users/$user_id': typeof AuthWorkspacesWorkspaceidDeploymentsDeploymentidUsersUseridIndexRoute
  '/workspaces/$workspace_id/devices/$device_id/parts/$part_id': typeof AuthWorkspacesWorkspaceidDevicesDeviceidPartsPartidIndexRoute
  '/workspaces/$workspace_id/maintenances/$maintenance_id/devices/$device_id': typeof AuthWorkspacesWorkspaceidMaintenancesMaintenanceidDevicesDeviceidIndexRoute
  '/workspaces/$workspace_id/settings/access/users/$user_id': typeof AuthWorkspacesWorkspaceidSettingsAccessUsersUseridIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_auth': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/terms-trial': typeof TermsTrialRoute
  '/_auth/academy': typeof AuthAcademyRoute
  '/_auth/end-of-trial': typeof AuthEndOfTrialRoute
  '/_auth/welcome': typeof AuthWelcomeRoute
  '/_auth/': typeof AuthIndexRoute
  '/_auth/account/profile': typeof AuthAccountProfileRoute
  '/account/password/request': typeof AccountPasswordRequestRoute
  '/account/verify/complete-invite': typeof AccountVerifyCompleteInviteRoute
  '/account/verify/complete-signup': typeof AccountVerifyCompleteSignupRoute
  '/_auth/workspaces/$workspace_id/device-insights': typeof AuthWorkspacesWorkspaceidDeviceInsightsRouteRouteWithChildren
  '/_auth/account/password/reset': typeof AuthAccountPasswordResetRoute
  '/_auth/account/password/set': typeof AuthAccountPasswordSetRoute
  '/_auth/workspaces/$workspace_id/customer-workspaces': typeof AuthWorkspacesWorkspaceidCustomerWorkspacesRoute
  '/_auth/workspaces/$workspace_id/overview': typeof AuthWorkspacesWorkspaceidOverviewRoute
  '/account/verify/$type/$token': typeof AccountVerifyTypeTokenRoute
  '/_auth/workspaces/$workspace_id/': typeof AuthWorkspacesWorkspaceidIndexRoute
  '/_auth/workspaces/$workspace_id/cases/type': typeof AuthWorkspacesWorkspaceidCasesTypeRouteRouteWithChildren
  '/_auth/workspaces/$workspace_id/maintenances/type': typeof AuthWorkspacesWorkspaceidMaintenancesTypeRouteRouteWithChildren
  '/_auth/workspaces/$workspace_id/settings/custom-inventory': typeof AuthWorkspacesWorkspaceidSettingsCustomInventoryRouteRouteWithChildren
  '/_auth/workspaces/$workspace_id/settings/tags': typeof AuthWorkspacesWorkspaceidSettingsTagsRouteRouteWithChildren
  '/_auth/workspaces/$workspace_id/inventory/activities': typeof AuthWorkspacesWorkspaceidInventoryActivitiesRoute
  '/_auth/workspaces/$workspace_id/inventory/assembled': typeof AuthWorkspacesWorkspaceidInventoryAssembledRoute
  '/_auth/workspaces/$workspace_id/inventory/constraints': typeof AuthWorkspacesWorkspaceidInventoryConstraintsRoute
  '/_auth/workspaces/$workspace_id/settings/details': typeof AuthWorkspacesWorkspaceidSettingsDetailsRoute
  '/_auth/workspaces/$workspace_id/settings/profile': typeof AuthWorkspacesWorkspaceidSettingsProfileRoute
  '/_auth/workspaces/$workspace_id/cases/': typeof AuthWorkspacesWorkspaceidCasesIndexRoute
  '/_auth/workspaces/$workspace_id/checklist-templates/': typeof AuthWorkspacesWorkspaceidChecklistTemplatesIndexRoute
  '/_auth/workspaces/$workspace_id/deployments/': typeof AuthWorkspacesWorkspaceidDeploymentsIndexRoute
  '/_auth/workspaces/$workspace_id/devices/': typeof AuthWorkspacesWorkspaceidDevicesIndexRoute
  '/_auth/workspaces/$workspace_id/maintenance-strategies/': typeof AuthWorkspacesWorkspaceidMaintenanceStrategiesIndexRoute
  '/_auth/workspaces/$workspace_id/maintenances/': typeof AuthWorkspacesWorkspaceidMaintenancesIndexRoute
  '/_auth/workspaces/$workspace_id/cases/$case_id/': typeof AuthWorkspacesWorkspaceidCasesCaseidIndexRoute
  '/_auth/workspaces/$workspace_id/checklist-templates/$checklist_template_id/': typeof AuthWorkspacesWorkspaceidChecklistTemplatesChecklisttemplateidIndexRoute
  '/_auth/workspaces/$workspace_id/deployments/$deployment_id/': typeof AuthWorkspacesWorkspaceidDeploymentsDeploymentidIndexRoute
  '/_auth/workspaces/$workspace_id/device-insights/$type/': typeof AuthWorkspacesWorkspaceidDeviceInsightsTypeIndexRoute
  '/_auth/workspaces/$workspace_id/devices/$device_id/': typeof AuthWorkspacesWorkspaceidDevicesDeviceidIndexRoute
  '/_auth/workspaces/$workspace_id/inventory/parts/': typeof AuthWorkspacesWorkspaceidInventoryPartsIndexRoute
  '/_auth/workspaces/$workspace_id/maintenance-strategies/$maintenance_strategy_id/': typeof AuthWorkspacesWorkspaceidMaintenanceStrategiesMaintenancestrategyidIndexRoute
  '/_auth/workspaces/$workspace_id/maintenances/$maintenance_id/': typeof AuthWorkspacesWorkspaceidMaintenancesMaintenanceidIndexRoute
  '/_auth/workspaces/$workspace_id/settings/access/': typeof AuthWorkspacesWorkspaceidSettingsAccessIndexRoute
  '/_auth/workspaces/$workspace_id/cases/type/$type/': typeof AuthWorkspacesWorkspaceidCasesTypeTypeIndexRoute
  '/_auth/workspaces/$workspace_id/inventory/parts/$part_id/': typeof AuthWorkspacesWorkspaceidInventoryPartsPartidIndexRoute
  '/_auth/workspaces/$workspace_id/maintenances/type/$type/': typeof AuthWorkspacesWorkspaceidMaintenancesTypeTypeIndexRoute
  '/_auth/workspaces/$workspace_id/settings/custom-inventory/$type/': typeof AuthWorkspacesWorkspaceidSettingsCustomInventoryTypeIndexRoute
  '/_auth/workspaces/$workspace_id/settings/tags/$type/': typeof AuthWorkspacesWorkspaceidSettingsTagsTypeIndexRoute
  '/_auth/workspaces/$workspace_id/deployments/$deployment_id/users/$user_id/': typeof AuthWorkspacesWorkspaceidDeploymentsDeploymentidUsersUseridIndexRoute
  '/_auth/workspaces/$workspace_id/devices/$device_id/parts/$part_id/': typeof AuthWorkspacesWorkspaceidDevicesDeviceidPartsPartidIndexRoute
  '/_auth/workspaces/$workspace_id/maintenances/$maintenance_id/devices/$device_id/': typeof AuthWorkspacesWorkspaceidMaintenancesMaintenanceidDevicesDeviceidIndexRoute
  '/_auth/workspaces/$workspace_id/settings/access/users/$user_id/': typeof AuthWorkspacesWorkspaceidSettingsAccessUsersUseridIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/login'
    | '/logout'
    | '/privacy'
    | '/register'
    | '/terms-trial'
    | '/academy'
    | '/end-of-trial'
    | '/welcome'
    | '/'
    | '/account/profile'
    | '/account/password/request'
    | '/account/verify/complete-invite'
    | '/account/verify/complete-signup'
    | '/workspaces/$workspace_id/device-insights'
    | '/account/password/reset'
    | '/account/password/set'
    | '/workspaces/$workspace_id/customer-workspaces'
    | '/workspaces/$workspace_id/overview'
    | '/account/verify/$type/$token'
    | '/workspaces/$workspace_id'
    | '/workspaces/$workspace_id/cases/type'
    | '/workspaces/$workspace_id/maintenances/type'
    | '/workspaces/$workspace_id/settings/custom-inventory'
    | '/workspaces/$workspace_id/settings/tags'
    | '/workspaces/$workspace_id/inventory/activities'
    | '/workspaces/$workspace_id/inventory/assembled'
    | '/workspaces/$workspace_id/inventory/constraints'
    | '/workspaces/$workspace_id/settings/details'
    | '/workspaces/$workspace_id/settings/profile'
    | '/workspaces/$workspace_id/cases'
    | '/workspaces/$workspace_id/checklist-templates'
    | '/workspaces/$workspace_id/deployments'
    | '/workspaces/$workspace_id/devices'
    | '/workspaces/$workspace_id/maintenance-strategies'
    | '/workspaces/$workspace_id/maintenances'
    | '/workspaces/$workspace_id/cases/$case_id'
    | '/workspaces/$workspace_id/checklist-templates/$checklist_template_id'
    | '/workspaces/$workspace_id/deployments/$deployment_id'
    | '/workspaces/$workspace_id/device-insights/$type'
    | '/workspaces/$workspace_id/devices/$device_id'
    | '/workspaces/$workspace_id/inventory/parts'
    | '/workspaces/$workspace_id/maintenance-strategies/$maintenance_strategy_id'
    | '/workspaces/$workspace_id/maintenances/$maintenance_id'
    | '/workspaces/$workspace_id/settings/access'
    | '/workspaces/$workspace_id/cases/type/$type'
    | '/workspaces/$workspace_id/inventory/parts/$part_id'
    | '/workspaces/$workspace_id/maintenances/type/$type'
    | '/workspaces/$workspace_id/settings/custom-inventory/$type'
    | '/workspaces/$workspace_id/settings/tags/$type'
    | '/workspaces/$workspace_id/deployments/$deployment_id/users/$user_id'
    | '/workspaces/$workspace_id/devices/$device_id/parts/$part_id'
    | '/workspaces/$workspace_id/maintenances/$maintenance_id/devices/$device_id'
    | '/workspaces/$workspace_id/settings/access/users/$user_id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/logout'
    | '/privacy'
    | '/register'
    | '/terms-trial'
    | '/academy'
    | '/end-of-trial'
    | '/welcome'
    | '/'
    | '/account/profile'
    | '/account/password/request'
    | '/account/verify/complete-invite'
    | '/account/verify/complete-signup'
    | '/workspaces/$workspace_id/device-insights'
    | '/account/password/reset'
    | '/account/password/set'
    | '/workspaces/$workspace_id/customer-workspaces'
    | '/workspaces/$workspace_id/overview'
    | '/account/verify/$type/$token'
    | '/workspaces/$workspace_id'
    | '/workspaces/$workspace_id/cases/type'
    | '/workspaces/$workspace_id/maintenances/type'
    | '/workspaces/$workspace_id/settings/custom-inventory'
    | '/workspaces/$workspace_id/settings/tags'
    | '/workspaces/$workspace_id/inventory/activities'
    | '/workspaces/$workspace_id/inventory/assembled'
    | '/workspaces/$workspace_id/inventory/constraints'
    | '/workspaces/$workspace_id/settings/details'
    | '/workspaces/$workspace_id/settings/profile'
    | '/workspaces/$workspace_id/cases'
    | '/workspaces/$workspace_id/checklist-templates'
    | '/workspaces/$workspace_id/deployments'
    | '/workspaces/$workspace_id/devices'
    | '/workspaces/$workspace_id/maintenance-strategies'
    | '/workspaces/$workspace_id/maintenances'
    | '/workspaces/$workspace_id/cases/$case_id'
    | '/workspaces/$workspace_id/checklist-templates/$checklist_template_id'
    | '/workspaces/$workspace_id/deployments/$deployment_id'
    | '/workspaces/$workspace_id/device-insights/$type'
    | '/workspaces/$workspace_id/devices/$device_id'
    | '/workspaces/$workspace_id/inventory/parts'
    | '/workspaces/$workspace_id/maintenance-strategies/$maintenance_strategy_id'
    | '/workspaces/$workspace_id/maintenances/$maintenance_id'
    | '/workspaces/$workspace_id/settings/access'
    | '/workspaces/$workspace_id/cases/type/$type'
    | '/workspaces/$workspace_id/inventory/parts/$part_id'
    | '/workspaces/$workspace_id/maintenances/type/$type'
    | '/workspaces/$workspace_id/settings/custom-inventory/$type'
    | '/workspaces/$workspace_id/settings/tags/$type'
    | '/workspaces/$workspace_id/deployments/$deployment_id/users/$user_id'
    | '/workspaces/$workspace_id/devices/$device_id/parts/$part_id'
    | '/workspaces/$workspace_id/maintenances/$maintenance_id/devices/$device_id'
    | '/workspaces/$workspace_id/settings/access/users/$user_id'
  id:
    | '__root__'
    | '/_auth'
    | '/login'
    | '/logout'
    | '/privacy'
    | '/register'
    | '/terms-trial'
    | '/_auth/academy'
    | '/_auth/end-of-trial'
    | '/_auth/welcome'
    | '/_auth/'
    | '/_auth/account/profile'
    | '/account/password/request'
    | '/account/verify/complete-invite'
    | '/account/verify/complete-signup'
    | '/_auth/workspaces/$workspace_id/device-insights'
    | '/_auth/account/password/reset'
    | '/_auth/account/password/set'
    | '/_auth/workspaces/$workspace_id/customer-workspaces'
    | '/_auth/workspaces/$workspace_id/overview'
    | '/account/verify/$type/$token'
    | '/_auth/workspaces/$workspace_id/'
    | '/_auth/workspaces/$workspace_id/cases/type'
    | '/_auth/workspaces/$workspace_id/maintenances/type'
    | '/_auth/workspaces/$workspace_id/settings/custom-inventory'
    | '/_auth/workspaces/$workspace_id/settings/tags'
    | '/_auth/workspaces/$workspace_id/inventory/activities'
    | '/_auth/workspaces/$workspace_id/inventory/assembled'
    | '/_auth/workspaces/$workspace_id/inventory/constraints'
    | '/_auth/workspaces/$workspace_id/settings/details'
    | '/_auth/workspaces/$workspace_id/settings/profile'
    | '/_auth/workspaces/$workspace_id/cases/'
    | '/_auth/workspaces/$workspace_id/checklist-templates/'
    | '/_auth/workspaces/$workspace_id/deployments/'
    | '/_auth/workspaces/$workspace_id/devices/'
    | '/_auth/workspaces/$workspace_id/maintenance-strategies/'
    | '/_auth/workspaces/$workspace_id/maintenances/'
    | '/_auth/workspaces/$workspace_id/cases/$case_id/'
    | '/_auth/workspaces/$workspace_id/checklist-templates/$checklist_template_id/'
    | '/_auth/workspaces/$workspace_id/deployments/$deployment_id/'
    | '/_auth/workspaces/$workspace_id/device-insights/$type/'
    | '/_auth/workspaces/$workspace_id/devices/$device_id/'
    | '/_auth/workspaces/$workspace_id/inventory/parts/'
    | '/_auth/workspaces/$workspace_id/maintenance-strategies/$maintenance_strategy_id/'
    | '/_auth/workspaces/$workspace_id/maintenances/$maintenance_id/'
    | '/_auth/workspaces/$workspace_id/settings/access/'
    | '/_auth/workspaces/$workspace_id/cases/type/$type/'
    | '/_auth/workspaces/$workspace_id/inventory/parts/$part_id/'
    | '/_auth/workspaces/$workspace_id/maintenances/type/$type/'
    | '/_auth/workspaces/$workspace_id/settings/custom-inventory/$type/'
    | '/_auth/workspaces/$workspace_id/settings/tags/$type/'
    | '/_auth/workspaces/$workspace_id/deployments/$deployment_id/users/$user_id/'
    | '/_auth/workspaces/$workspace_id/devices/$device_id/parts/$part_id/'
    | '/_auth/workspaces/$workspace_id/maintenances/$maintenance_id/devices/$device_id/'
    | '/_auth/workspaces/$workspace_id/settings/access/users/$user_id/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  PrivacyRoute: typeof PrivacyRoute
  RegisterRoute: typeof RegisterRoute
  TermsTrialRoute: typeof TermsTrialRoute
  AccountPasswordRequestRoute: typeof AccountPasswordRequestRoute
  AccountVerifyCompleteInviteRoute: typeof AccountVerifyCompleteInviteRoute
  AccountVerifyCompleteSignupRoute: typeof AccountVerifyCompleteSignupRoute
  AccountVerifyTypeTokenRoute: typeof AccountVerifyTypeTokenRoute
}

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  PrivacyRoute: PrivacyRoute,
  RegisterRoute: RegisterRoute,
  TermsTrialRoute: TermsTrialRoute,
  AccountPasswordRequestRoute: AccountPasswordRequestRoute,
  AccountVerifyCompleteInviteRoute: AccountVerifyCompleteInviteRoute,
  AccountVerifyCompleteSignupRoute: AccountVerifyCompleteSignupRoute,
  AccountVerifyTypeTokenRoute: AccountVerifyTypeTokenRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_auth",
        "/login",
        "/logout",
        "/privacy",
        "/register",
        "/terms-trial",
        "/account/password/request",
        "/account/verify/complete-invite",
        "/account/verify/complete-signup",
        "/account/verify/$type/$token"
      ]
    },
    "/_auth": {
      "filePath": "_auth.tsx",
      "children": [
        "/_auth/academy",
        "/_auth/end-of-trial",
        "/_auth/welcome",
        "/_auth/",
        "/_auth/account/profile",
        "/_auth/workspaces/$workspace_id/device-insights",
        "/_auth/account/password/reset",
        "/_auth/account/password/set",
        "/_auth/workspaces/$workspace_id/customer-workspaces",
        "/_auth/workspaces/$workspace_id/overview",
        "/_auth/workspaces/$workspace_id/",
        "/_auth/workspaces/$workspace_id/cases/type",
        "/_auth/workspaces/$workspace_id/maintenances/type",
        "/_auth/workspaces/$workspace_id/settings/custom-inventory",
        "/_auth/workspaces/$workspace_id/settings/tags",
        "/_auth/workspaces/$workspace_id/inventory/activities",
        "/_auth/workspaces/$workspace_id/inventory/assembled",
        "/_auth/workspaces/$workspace_id/inventory/constraints",
        "/_auth/workspaces/$workspace_id/settings/details",
        "/_auth/workspaces/$workspace_id/settings/profile",
        "/_auth/workspaces/$workspace_id/cases/",
        "/_auth/workspaces/$workspace_id/checklist-templates/",
        "/_auth/workspaces/$workspace_id/deployments/",
        "/_auth/workspaces/$workspace_id/devices/",
        "/_auth/workspaces/$workspace_id/maintenance-strategies/",
        "/_auth/workspaces/$workspace_id/maintenances/",
        "/_auth/workspaces/$workspace_id/cases/$case_id/",
        "/_auth/workspaces/$workspace_id/checklist-templates/$checklist_template_id/",
        "/_auth/workspaces/$workspace_id/deployments/$deployment_id/",
        "/_auth/workspaces/$workspace_id/devices/$device_id/",
        "/_auth/workspaces/$workspace_id/inventory/parts/",
        "/_auth/workspaces/$workspace_id/maintenance-strategies/$maintenance_strategy_id/",
        "/_auth/workspaces/$workspace_id/maintenances/$maintenance_id/",
        "/_auth/workspaces/$workspace_id/settings/access/",
        "/_auth/workspaces/$workspace_id/inventory/parts/$part_id/",
        "/_auth/workspaces/$workspace_id/deployments/$deployment_id/users/$user_id/",
        "/_auth/workspaces/$workspace_id/devices/$device_id/parts/$part_id/",
        "/_auth/workspaces/$workspace_id/maintenances/$maintenance_id/devices/$device_id/",
        "/_auth/workspaces/$workspace_id/settings/access/users/$user_id/"
      ]
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/logout": {
      "filePath": "logout.tsx"
    },
    "/privacy": {
      "filePath": "privacy.tsx"
    },
    "/register": {
      "filePath": "register.tsx"
    },
    "/terms-trial": {
      "filePath": "terms-trial.tsx"
    },
    "/_auth/academy": {
      "filePath": "_auth/academy.tsx",
      "parent": "/_auth"
    },
    "/_auth/end-of-trial": {
      "filePath": "_auth/end-of-trial.tsx",
      "parent": "/_auth"
    },
    "/_auth/welcome": {
      "filePath": "_auth/welcome.tsx",
      "parent": "/_auth"
    },
    "/_auth/": {
      "filePath": "_auth/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/account/profile": {
      "filePath": "_auth/account/profile.tsx",
      "parent": "/_auth"
    },
    "/account/password/request": {
      "filePath": "account/password/request.tsx"
    },
    "/account/verify/complete-invite": {
      "filePath": "account/verify/complete-invite.tsx"
    },
    "/account/verify/complete-signup": {
      "filePath": "account/verify/complete-signup.tsx"
    },
    "/_auth/workspaces/$workspace_id/device-insights": {
      "filePath": "_auth/workspaces/$workspace_id/device-insights/route.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/workspaces/$workspace_id/device-insights/$type/"
      ]
    },
    "/_auth/account/password/reset": {
      "filePath": "_auth/account/password/reset.tsx",
      "parent": "/_auth"
    },
    "/_auth/account/password/set": {
      "filePath": "_auth/account/password/set.tsx",
      "parent": "/_auth"
    },
    "/_auth/workspaces/$workspace_id/customer-workspaces": {
      "filePath": "_auth/workspaces/$workspace_id/customer-workspaces.tsx",
      "parent": "/_auth"
    },
    "/_auth/workspaces/$workspace_id/overview": {
      "filePath": "_auth/workspaces/$workspace_id/overview.tsx",
      "parent": "/_auth"
    },
    "/account/verify/$type/$token": {
      "filePath": "account/verify/$type/$token.tsx"
    },
    "/_auth/workspaces/$workspace_id/": {
      "filePath": "_auth/workspaces/$workspace_id/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/workspaces/$workspace_id/cases/type": {
      "filePath": "_auth/workspaces/$workspace_id/cases/type/route.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/workspaces/$workspace_id/cases/type/$type/"
      ]
    },
    "/_auth/workspaces/$workspace_id/maintenances/type": {
      "filePath": "_auth/workspaces/$workspace_id/maintenances/type/route.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/workspaces/$workspace_id/maintenances/type/$type/"
      ]
    },
    "/_auth/workspaces/$workspace_id/settings/custom-inventory": {
      "filePath": "_auth/workspaces/$workspace_id/settings/custom-inventory/route.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/workspaces/$workspace_id/settings/custom-inventory/$type/"
      ]
    },
    "/_auth/workspaces/$workspace_id/settings/tags": {
      "filePath": "_auth/workspaces/$workspace_id/settings/tags/route.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/workspaces/$workspace_id/settings/tags/$type/"
      ]
    },
    "/_auth/workspaces/$workspace_id/inventory/activities": {
      "filePath": "_auth/workspaces/$workspace_id/inventory/activities.tsx",
      "parent": "/_auth"
    },
    "/_auth/workspaces/$workspace_id/inventory/assembled": {
      "filePath": "_auth/workspaces/$workspace_id/inventory/assembled.tsx",
      "parent": "/_auth"
    },
    "/_auth/workspaces/$workspace_id/inventory/constraints": {
      "filePath": "_auth/workspaces/$workspace_id/inventory/constraints.tsx",
      "parent": "/_auth"
    },
    "/_auth/workspaces/$workspace_id/settings/details": {
      "filePath": "_auth/workspaces/$workspace_id/settings/details.tsx",
      "parent": "/_auth"
    },
    "/_auth/workspaces/$workspace_id/settings/profile": {
      "filePath": "_auth/workspaces/$workspace_id/settings/profile.tsx",
      "parent": "/_auth"
    },
    "/_auth/workspaces/$workspace_id/cases/": {
      "filePath": "_auth/workspaces/$workspace_id/cases/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/workspaces/$workspace_id/checklist-templates/": {
      "filePath": "_auth/workspaces/$workspace_id/checklist-templates/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/workspaces/$workspace_id/deployments/": {
      "filePath": "_auth/workspaces/$workspace_id/deployments/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/workspaces/$workspace_id/devices/": {
      "filePath": "_auth/workspaces/$workspace_id/devices/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/workspaces/$workspace_id/maintenance-strategies/": {
      "filePath": "_auth/workspaces/$workspace_id/maintenance-strategies/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/workspaces/$workspace_id/maintenances/": {
      "filePath": "_auth/workspaces/$workspace_id/maintenances/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/workspaces/$workspace_id/cases/$case_id/": {
      "filePath": "_auth/workspaces/$workspace_id/cases/$case_id/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/workspaces/$workspace_id/checklist-templates/$checklist_template_id/": {
      "filePath": "_auth/workspaces/$workspace_id/checklist-templates/$checklist_template_id/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/workspaces/$workspace_id/deployments/$deployment_id/": {
      "filePath": "_auth/workspaces/$workspace_id/deployments/$deployment_id/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/workspaces/$workspace_id/device-insights/$type/": {
      "filePath": "_auth/workspaces/$workspace_id/device-insights/$type/index.tsx",
      "parent": "/_auth/workspaces/$workspace_id/device-insights"
    },
    "/_auth/workspaces/$workspace_id/devices/$device_id/": {
      "filePath": "_auth/workspaces/$workspace_id/devices/$device_id/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/workspaces/$workspace_id/inventory/parts/": {
      "filePath": "_auth/workspaces/$workspace_id/inventory/parts/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/workspaces/$workspace_id/maintenance-strategies/$maintenance_strategy_id/": {
      "filePath": "_auth/workspaces/$workspace_id/maintenance-strategies/$maintenance_strategy_id/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/workspaces/$workspace_id/maintenances/$maintenance_id/": {
      "filePath": "_auth/workspaces/$workspace_id/maintenances/$maintenance_id/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/workspaces/$workspace_id/settings/access/": {
      "filePath": "_auth/workspaces/$workspace_id/settings/access/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/workspaces/$workspace_id/cases/type/$type/": {
      "filePath": "_auth/workspaces/$workspace_id/cases/type/$type/index.tsx",
      "parent": "/_auth/workspaces/$workspace_id/cases/type"
    },
    "/_auth/workspaces/$workspace_id/inventory/parts/$part_id/": {
      "filePath": "_auth/workspaces/$workspace_id/inventory/parts/$part_id/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/workspaces/$workspace_id/maintenances/type/$type/": {
      "filePath": "_auth/workspaces/$workspace_id/maintenances/type/$type/index.tsx",
      "parent": "/_auth/workspaces/$workspace_id/maintenances/type"
    },
    "/_auth/workspaces/$workspace_id/settings/custom-inventory/$type/": {
      "filePath": "_auth/workspaces/$workspace_id/settings/custom-inventory/$type/index.tsx",
      "parent": "/_auth/workspaces/$workspace_id/settings/custom-inventory"
    },
    "/_auth/workspaces/$workspace_id/settings/tags/$type/": {
      "filePath": "_auth/workspaces/$workspace_id/settings/tags/$type/index.tsx",
      "parent": "/_auth/workspaces/$workspace_id/settings/tags"
    },
    "/_auth/workspaces/$workspace_id/deployments/$deployment_id/users/$user_id/": {
      "filePath": "_auth/workspaces/$workspace_id/deployments/$deployment_id/users/$user_id/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/workspaces/$workspace_id/devices/$device_id/parts/$part_id/": {
      "filePath": "_auth/workspaces/$workspace_id/devices/$device_id/parts/$part_id/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/workspaces/$workspace_id/maintenances/$maintenance_id/devices/$device_id/": {
      "filePath": "_auth/workspaces/$workspace_id/maintenances/$maintenance_id/devices/$device_id/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/workspaces/$workspace_id/settings/access/users/$user_id/": {
      "filePath": "_auth/workspaces/$workspace_id/settings/access/users/$user_id/index.tsx",
      "parent": "/_auth"
    }
  }
}
ROUTE_MANIFEST_END */
